import { createSlice } from "@reduxjs/toolkit";

/**
 * Whether the support chat widget is open. The widget used to keep this
 * as local state, which meant only its own launcher could open it; the
 * order page's Request a coverage increase action (docs/plans/
 * order-changes.md, decision 101) opens the chat from elsewhere after
 * its request lands in the thread, so the flag lives here and any page
 * can dispatch it. Nothing else about the widget moved: the thread and
 * unread queries stay its own.
 *
 * `headerLaunchers` counts the header support icons on the page. The
 * icon is the launcher wherever a header is (Tyler, 2026-10-09: nothing
 * floats over a page's bottom); a page without a header (the sign-up
 * steps, check-email, the 404) keeps the floating bubble, so the widget
 * draws it only while the count is 0. A count, not a flag, so a route
 * change that swaps one header for another can never leave it wrong.
 */
type SupportChatState = {
  open: boolean;
  headerLaunchers: number;
};

const initialState: SupportChatState = {
  open: false,
  headerLaunchers: 0,
};

export const supportChatSlice = createSlice({
  name: "supportChat",
  initialState,
  reducers: {
    openSupportChat: (state) => {
      state.open = true;
    },
    closeSupportChat: (state) => {
      state.open = false;
    },
    toggleSupportChat: (state) => {
      state.open = !state.open;
    },
    headerLauncherMounted: (state) => {
      state.headerLaunchers += 1;
    },
    headerLauncherUnmounted: (state) => {
      state.headerLaunchers -= 1;
    },
  },
});

export const {
  openSupportChat,
  closeSupportChat,
  toggleSupportChat,
  headerLauncherMounted,
  headerLauncherUnmounted,
} = supportChatSlice.actions;

export default supportChatSlice.reducer;
